<template>
  <div class="shadow-md bg-white">
    <div class="flex items-center justify-between lg:container lg:mx-auto">
      <div
        id="tomu-navbar"
        class="flex flex-col lg:flex-row flex-1 xl:flex-initial select-none"
      >
        <div
          class="
            flex-shrink-0 flex
            items-center
            justify-between
            shadow-md
            lg:shadow-none
            p-2
            lg:p-0
            z-10
          "
        >
          <router-link to="/">
            <img
              src="@/assets/images/logo-1x.jpg"
              class="tomu-navbar-logo"
              alt="ТомУниверсал логотип лого"
              title="ТомУниверсал логотип"
            />
          </router-link>
          <svg
            @click="isActive = !isActive"
            class="w-8 lg:hidden tomu-navbar-toggler"
            :class="{ 'tomu-navbar-toggler-focused': isActive }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              class="transition-opacity delay-75 ease-in-out opacity-0"
              :class="{ 'opacity-100': !isActive }"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M4 6h16M4 12h16M4 18h16"
            />
            <path
              class="transition-opacity delay-75 ease-in-out opacity-0"
              :class="{ 'opacity-100': isActive }"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M 6,6 L 18,18 M 6,18 L 18,6"
            />
          </svg>
        </div>
        <nav
          @click="click"
          :class="{ hidden: !isActive && isMobile }"
          class="tomu-navbar flex-col divide-y-2 lg:divide-y-0 lg:flex-row flex"
          role="navigation"
        >
          <router-link
            :to="{ name: 'Home' }"
            class="tomu-navbar-link"
            title="Главная"
          >
            Главная
          </router-link>
          <router-link
            :to="{ name: 'DigitalDriverCards' }"
            class="tomu-navbar-link"
            title="Карты водителя"
          >
            Карты водителя
          </router-link>
          <router-link
            :to="{ name: 'VehicleRegistrationPlates' }"
            class="tomu-navbar-link"
            title="Изготовление гос номеров"
            event=""
          >
            Изготовление гос номеров
          </router-link>
          <router-link
            :to="{ name: 'Documents' }"
            class="tomu-navbar-link"
            title="Документы"
          >
            Документы
          </router-link>
          <router-link
            :to="{ name: 'Contacts' }"
            class="tomu-navbar-link"
            title="Контакты"
          >
            Контакты
          </router-link>
        </nav>
      </div>
      <div class="hidden xl:flex items-center">
        <div class="tomu-navbar-contacts mr-4 flex-shrink-0">
          <div class="text-right">
            <p class="tomu-navbar-contacts__first">
              <vue-feather class="icon" type="map-pin"></vue-feather> Адрес:
              <span class="tomu-navbar-contacts__address"
                >г. Томск, ул. В. Высоцкого, 25 ст. 3</span
              >
            </p>
            <p class="tomu-navbar-contacts__second">
              <vue-feather class="icon" type="phone"></vue-feather>
              <span class="tomu-navbar-contacts__phone-number">
                (3822) <span class="tomu-underline">515-300</span></span
              >
              <vue-feather class="icon" type="mail"></vue-feather>
              <span class="tomu-navbar-contacts__email">
                office@tomuniversal.ru</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      isActive: false,
      isMobile: window.innerWidth < 1024,
    };
  },
  methods: {
    click() {
      if (this.isMobile === true && this.isActive === true) {
        this.isActive = false;
      }
    },
  },
  mounted() {
    addEventListener("resize", () => {
      this.isMobile = innerWidth < 1024;
    });
  },
};
</script>

<style scoped>
.tomu-navbar-logo {
  @apply h-14 lg:relative lg:-top-2.5;

  &:hover {
    filter: saturate(1.5);
  }
}

@responsive {
  .tomu-navbar-link.router-link-active {
    border-bottom-color: rgba(5, 150, 105, 1) !important;
    border-bottom-width: 3px !important;
  }
}

.tomu-navbar-link {
  @apply p-6;

  &.disabled {
    @apply text-gray-400 cursor-not-allowed;
  }

  &:hover {
    @apply bg-gray-50;
  }
  &:not(.disabled):hover {
    @apply text-green-500;
  }
}

.tomu-navbar-toggler-focused {
  outline: #00ad88 2px dashed;
  outline-offset: 4px;
}
</style>
